import { lazy } from 'react';
import { RouteProps } from '@/typings';

const Home = lazy(() => import('@/pages/Home'));
const RegistroEstudiante = lazy(() => import('@/pages/RegistroEstudiante'));
const TokenLoginOffice365 = lazy(() => import('@/pages/LoginOffice365'));
const EvaluacionJefeInmediato = lazy(
  () => import('@/pages/EvaluacionJefeInmediato')
);

const rutasPublicas: RouteProps[] = [
  {
    element: <Home />,
    index: true,
  },
  {
    path: '/Estudiante/Registro',
    element: <RegistroEstudiante />,
  },
  {
    path: '/signin-oidc',
    element: <TokenLoginOffice365 />,
  },
  {
    path: '/VistoBueno/:id/:hash',
    element: <EvaluacionJefeInmediato />,
  },
];

export default rutasPublicas;
